import useObjectUrl from './useObjectUrl'
export default useObjectUrl
